import { useState } from 'react';
import ProductNav from './overview/ProductNav';
import A from './overview/A';
import B from './overview/B';
import C from './overview/C';
import D from './overview/D';
import E from './overview/E';
import F from './overview/F';
import G from './overview/G';
import H from './overview/H';
import I from './overview/I';
import J from './overview/J';
// import K from './overview/K';
import L from './overview/L';
import M from './overview/M';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import FixProcess from './overview/FixProcess';
import ProductList from './overview/ProductList';

const OverView: React.FC = () => {
    const [activeTab, setActiveTab] = useState('Product');
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };

    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }

    return (
        <div className={`Page-Overview ${css.page}`}>
            <ProductNav activeTab={activeTab} tabCallback={tabCallback} />
            <A />
            <C />
            <ProductList />
            <J />
            <B />
            <D />
            <FixProcess />
            <E />
            <F />
            <G />
            <H />
            <I />
            {/* <K /> */}
            <L />
            <M />
        </div>
    );
};

export default OverView;
